const data = {
  home: {
    create: "创作",
    list: "创作列表",
    myContent: "我的内容",
    message: "消息",
    notice: "通知",
    creation: "我的创作",
    Setting: "设置",
    logout: "登出",
    language: "语言",
    content1: "请选择要建立的创作类别",
    content2: "创建游戏",
    content3: "什么是实景游戏",
    address: "佛山市高明区金穗大厦6楼",
    download: "App 下载",
    info1: "关于我们",
    info2: "实景游戏",
    info3: "智慧导览",
    info4: "企业合作",
    info5: "创建导览 / 游戏",
  },
  edit: {
    backContent: "返回创作列表",
    menu: {
      coverSetting: "封面设计",
      contentEdit: "内容编辑",
      more: "更多",
      plotEditing: "剧情编辑",
      gameEvent: "游戏事件",
      roleAndScene: "角色和场景",
      bifurcated: "分叉路线",
      gameDesign: "游戏阶级设计",
      collection: "道具收集",
      published: "游戏发布",
      storyBackground: "故事背景",
      pointManagement: "积分管理",
      questionnaire: "调查问卷",
    },
    cover: {
      title: "封面介绍",
      save: "保存",
      next: "下一步",
      gameTitle: "游戏标题",
      gameCategory: "游戏玩法",
      gameLanguage: "游戏语言",
      difficulty: "难易度",
      playTime: "游玩时间(分钟)",
      gameCover: "游戏封面图",
      gameDescription: "游戏简介",
      titleApp: "App示意画面-创作封面",
      app1: "关于",
      app2: "游戏难度",
      app3: "游戏时间",
      app4: "地图导航",
      app5: "介绍",
      opening_hours: "开放时间",
      experience_time: "门票预约",
      begin: "起点",
      end: "终点",
      walking_distance: "步行距离",
      estimated_time: "预估时间",
      Facilities_along_way: "沿途设施",
      multiplayer_game: "多人游戏",
      player_age: "玩家年龄",
      transportation: "交通方式",
      area: "地区",
      address: "地址",
      tag: "标签",
      slideshow: "轮播图:拖拽排序",
      research_characteristics: "研学特点",
    },
  },
  login: {
    title: "登录",
    username: "账号",
    usernamePlaceholder: "",
    password: "密码",
    passwordPlaceholder: "",
    submit: "提交",
    switch: "返回登录",
  },
  register: {
    title: "注册",
    switch: "去注册",
    submit: "提交",
  },
  settings: {
    title: "设置",
    username: "用户名",
    password: "密码",
    language: "语言",
    save: "保存",
    avatar: "头像",
    usernamePlaceholder: "输入您的用户名",
    passwordPlaceholder: "输入您的密码",
    confirmPassword: "确定密码",
    newPassword: "新密码",
    clearImg: "清除图片",
    back: "返回",
  },
  List: {
    button1: "返回",
    button2: "主页",
    button3: "编辑",
    button4: "删除",
    tip: "更新时间",
    deleteInfo: "是否删除游戏",
    channel: "取消",
    confirm: "确定",
    creationList: "创作列表",
    trashCan: "垃圾桶",
  },
  Content: {
    tip1: "拖拽排序",
    tip2: "游戏顺序为卡牌顺序",
    addLevel: "添加关卡",
    deleteInfo: "是否删除关卡",
    channel: "取消",
    confirm: "确定",
    gaud: "高德地图",
    customize: "自定义地图",
    contentEdit: "内容编辑",
    save: "保存",
  },
  Detail: {
    title: "标题",
    LevelTitle: "关卡标题",
    LevelContent: "关卡谜题内容",
    difficulty: "游戏难度",
    storeTitle: "故事标题",
    storeContent: "故事内容",
    clues: "游戏线索（最多上传3张图片）",
    answer: "谜题答案",
    tipTitle: "提示标题",
    tipContent: "提示内容",
    back: "返回",
    save: "保存",
  },
  common: {
    success1: "删除成功",
    success2: "修改成功",
    success3: "添加关卡",
    error1: "删除失败",
    error2: "修改失败",
    error3: "删除关卡",
    changePos: "更改位置",
  },
};

export default data;
